import { render, staticRenderFns } from "./NewTeamModal.vue?vue&type=template&id=b7c2d376&lang=pug"
import script from "./NewTeamModal.vue?vue&type=script&lang=js"
export * from "./NewTeamModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports